/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
import {Registration} from './components/Frontend_Auth_Components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import AdminLogin from './components/Backend_Auth_Components/AdminLogin'
import {FrontendLogin} from './components/Frontend_Auth_Components/FrontendLogin'
import ResetPassword from '../../pages/AdminPages/MyProfile/ResetPassword'
import PageLoading from '../../routing/PageLoading'
import {ENV} from '../../Utils/_helpers/EnvHelper'
import {InviteLink} from './components/Frontend_Auth_Components/InviteLink'

const AuthLayout = () => {
  const param = document.location.host
  const isCellcast = param === ENV().REACT_APP_CELLCAST;

  useEffect(() => {
    document?.body?.classList?.add('bg-white')
    return () => {
      document?.body?.classList?.remove('bg-white')
    }
  }, [])
  useEffect(() => {
    document.title = isCellcast ? 'Cellcast' : 'My Message Centre';
    
    let link: any = document.querySelector("link[rel~='icon']")
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.getElementsByTagName('head')[0].appendChild(link)
    }
    param !== ENV().REACT_APP_CELLCAST
      ? (link.href = toAbsoluteUrl('/media/logos/LogoSymbol.svg'))
      : (link.href = toAbsoluteUrl('/media/logos/LogoSymbol.svg'))
  }, [])

  return (
    <>
      <div className='auth-pages d-flex align-items-center min-vh-100'>
        <div className='container'>
          {isCellcast && (
            <img
              alt=''
              className='logo d-block d-md-inline mx-auto mx-md-0'
              src={toAbsoluteUrl('/media/logos/Logo.svg')}
            />
          )}
          <div className='row align-items-center'>
            <div className='col-md-6 mb-10 mb-md-0 pe-3 pe-md-5 pe-lg-10 pe-xl-15 order-2 order-md-1'>
              {/* {(param === 'localhost:3012' || param == '54.153.213.30:3012') && (
                <>
                  <img alt='' className='me-3 logo' src={toAbsoluteUrl('/media/logos/Logo.svg')} />
                  <h1 className='page-title'>
                    Make the best decision for your business with Cellcast
                  </h1>
                </>
              )} */}
              <img alt='' className='' src={toAbsoluteUrl('/media/auth/login-left.png')} />
            </div>
            <div className='col-md-6 order-1 order-md-2'>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const AuthPage = () => {
  const isAdminAsUserRefresh = localStorage.getItem('isAdminAsUserRefresh') ?? 'false'
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path='reset-password' element={<ResetPassword />} />
        <Route path='login' element={<FrontendLogin />} />
        <Route path='registration' element={<Registration />} />
        <Route path='invite-link' element={<InviteLink />} />
        <Route path='forgot-password' element={<ForgotPassword />} />
        <Route path='admin' element={<AdminLogin />} />
        {isAdminAsUserRefresh === 'true' ? (
          <Route index element={<PageLoading />} />
        ) : (
          <Route index element={<FrontendLogin />} />
        )}
      </Route>
    </Routes>
  )
}

export {AuthPage}
